
import {
  AppBar,
  Toolbar,
  CssBaseline,
  makeStyles,
  IconButton,
  Box,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { CustomSidebarSearchModal } from './CustomSidebarSearchModal';
import TietoLogo from '../../assets/logo/lifecare-logo.svg';
import UserProfileInfo from './user-info';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(1.5),
    color: '#ffffff',
  },
  svg: {
    width: '7.5rem',
  },
  searchButton: {
    color: '#ffffff !important',
    marginRight: 0,
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    padding: theme.spacing(1),
    '& svg': {
      color: '#ffffff !important',
    },
  },
}));

type TopBarProps = {
  onMenuClick: () => void;
};

export const TopBar = ({ onMenuClick }: TopBarProps) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <CssBaseline />
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        <Box display="flex" flexGrow={1} alignItems="center">
          <NavLink to="/" style={{ display: 'flex' }}>
            <img
              src={TietoLogo}
              className={classes.svg}
              alt="Lifecare Open Platform"
              title="Lifecare Open Platform"
            />
          </NavLink>
        </Box>
        <IconButton
          className={classes.searchButton}
          edge="end"
          color="inherit"
          aria-label="search"
        >
          <CustomSidebarSearchModal />
        </IconButton>
        <UserProfileInfo />
      </Toolbar>
    </AppBar>
  );
};
